export const EXAMPLE = 'EXAMPLE'
